import "./App.css";
import { useMemo } from "react";

import Minter from "./Minter";

import * as anchor from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSolflareWallet,
  getSolletWallet,
  getMathWallet,
} from "@solana/wallet-adapter-wallets";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";

import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { ThemeProvider, createTheme } from "@material-ui/core";


const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const candyMachineId = process.env.REACT_APP_CANDY_MACHINE_ID
  ? new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID)
  : undefined;

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [getPhantomWallet(), getSolflareWallet(), getSolletWallet(), getMathWallet() ],
    []
  );

  function toggleMenu() {
    const menu = document.getElementById("mobileNavContainer")!;
    menu.classList.toggle("open-menu");
    console.log("pressed");
  }

  return (
    <div>

      <div className="content-wrapper" >
          <header className="card" id="link1">
            <div style={{ padding: "0 340px 0 24px 0" }}>
            <img className="nav-logo" src="/img/logo.png" alt="" />
              <p className="text-secondary-color text-center">
                
              <img className="lolphin" src="/img/lolphins.gif"/>
              </p>
            </div>
            <div>
              <p className="text-secondary-color text-start text-margin" id="just-line-break">
                I believe in opportunities.<br/><br/> I feel the Solana ecosystem is a great place to build a community to network on, built on trust. <br/><br/>I have realized that networking could result more benefitial
                to us than making a quick buck in the long term, money come and goes but opportunities, opportunities are hardly presented to us. <br/><br/> That is why I want to build a community and give the power 
                of it to the same community, giving each other a hand to make great things happen. Imagine all the different talents, skills and all the knowledge that reside in the Solana ecosystem.<br/><br/> 
                My vision is to create a community where people that have can help to those who ask for it. 
              
              </p>
              
            </div>
          </header>

          <div id="link2" className="container">
          </div>

          <div id="link3" className="container card">
            <h4 className="pb-3 text-center">Los lolphins club is here to stay. We choose to give the power to the community since the beginning. 
            We plan to make this the most exclusive, diverse networking community Solana has ever seen.</h4>
            <h1 className="pb-2 text-center">"Not here to make a quick buck, but to make a mark."</h1>
          </div>

          <div id="link4" className="container faq">
            <h1 style={{ padding: "0 0 24px 0" }}>FAQ</h1>
            <div>
              <h4>No roadmap?</h4>
              <p>
                No. 
                I believe making false promises is the major reason why most projects fail.
                Offering the community the chance to make its own roadmap to benefit themselves will be our way to go.
              </p>
                
              <hr />
            </div>

            <div>
              <h4>Supply, price, launch date?</h4>
              <p>
                My plan is to open our discord whenever we have the first 100 whitelist spots from twitter, this way everyone can have a vote. 
                Votes for each category will be held and discussed in our discord once we have our members ready. Discord will remain closed to public.
              </p>

              <hr />
            </div>

            <div>
              <h4>Why this concept?</h4>
              <p>
                I feel projects offering too much endup building a wall between the leaders and the community thus, making them fail to colaborate for the better of the project.
                I have come to the realization of the potential benefit of making a community to network with people all around the world with all kind of skills and backgrounds will be more valuable than making a quick buck.
              </p>

              <hr />
            </div>
          </div>
      </div>
      <nav>
        <div className="nav-container">
          <div className="social-icons hide-800">
            <a href="https://discord.gg/"><img className="nav-social" src="/icons/discord.svg" alt="" /></a>
            <a href="https://twitter.com/loslolphins"><img className="nav-social" src="/icons/twitter.svg" alt="" /></a>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default App;
